import {onFind} from "@elements/init-modules-in-scope";
import {on, closest, find, findIn, addClass, removeClass} from "@elements/dom-utils";

export function init () {
    onFind('.js-filter-box-group__collapse-btn', function (item) {
        let container = closest('.js-filter-box-group', item);
        let target = find(item.getAttribute('data-bs-target'));
        let input = findIn('.js-filter-box-group__state', closest('.js-filter-box-group', item));

        target.addEventListener('hide.bs.collapse', function () {
            input.value = "false"

            addClass('is-collapsed', container);
        });

        target.addEventListener('shown.bs.collapse', function () {
            input.value = "true"

            removeClass('is-collapsed', container);
        });
    });
}
